import { render, staticRenderFns } from "./SearchClaimRequestsHeader.vue?vue&type=template&id=42fdde00&"
import script from "./SearchClaimRequestsHeader.vue?vue&type=script&lang=js&"
export * from "./SearchClaimRequestsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchClaimRequestsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports